import React, { useState } from 'react';
import "./FaqSection.css"
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const faqItems = [
    {
        number: "01",
        title: "How do AI agents in AgentScrum enhance agile operations? ",
        content:
            "AI agents automate backlog grooming, sprint planning, daily standups, and reporting—boosting team velocity, predictability, and overall sprint efficiency.",
    },
    {
        number: "02",
        title: "What kind of data does AgentScrum need to operate? ",
        content:
            " AgentScrum leverages sprint history, team availability, task status, backlog metadata, and tool integration data from platforms like Jira, Slack, and Git. ",
    },
    {
        number: "03",
        title: "Can AgentScrum be customized for different agile frameworks?",
        content:
            " Yes, AgentScrum is fully configurable to support Scrum, Kanban, or hybrid agile models. You can tailor workflows, autonomy levels, and notifications.",
    },
    {
        number: "04",
        title: "How fast can I deploy AgentScrum for my team? ",
        content:
            " AgentScrum can be deployed in under 24 hours with pre-built integrations. A guided onboarding session helps your team get started immediately. ",
    },
    {
        number: "04",
        title: "Is training required for my team to use AgentScrum?  ",
        content:
            " No formal training is required. AgentScrum features an intuitive interface, and optional tutorials and in-app guidance are available to support onboarding. ",
    },
    {
        number: "04",
        title: "Does AgentScrum integrate with our existing tools? ",
        content:
            " Yes, AgentScrum seamlessly integrates with popular tools like Jira, Confluence, Slack, Outlook, Zoom, and Git—centralizing workflows and enhancing collaboration across your agile stack.",
    },
];

const FaqSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

    return (
        <section className={`second-faq-section ${isVisible ? "section-animation" : ""}`}
            ref={ref}
            id="five">
            {/* second-accordion-container */}
            <div className="container ">
                <div className="content-tag">
                    <h2 className='colored-text-1'>About</h2>
                </div>
                <div className="second-faq-section-heading">
                    <h2>AgentScrum FAQs: Your Guide to Common Inquiries</h2>
                    <p>Have questions about AgentScrum? You’re in the right place. Discover how intelligent automation enhances your agile workflows—from sprint planning to daily standups—with seamless, AI-powered support</p>
                </div>
                <div className="second-accordion">
                    {faqItems.map((item, index) => (
                        <div className="second-accordion-item" key={index}>
                            <button
                                id={`second-accordion-button-${index}`}
                                aria-expanded={openIndex === index}
                                onClick={() => toggleAccordion(index)}
                            >
                                <span className="second-accordion-title">{item.title}</span>
                                <span className="icon" aria-hidden="true">
                                    {openIndex === index ? '' : ''}
                                </span>
                            </button>
                            {openIndex === index && (
                                <div className="second-accordion-content">
                                    <p>{item.content}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
